import { componentWrapper } from "../../utilities";
import { Popover } from "../popover";
import { Body, Dropdown, Footer, Header } from "./popover-info-card-components";
import { POPOVER_INFO_CARD_WIDTH } from "./popover-info-card.constants";
import type { CustomPopoverInfoCardFactory, IProps } from "./popover-info-card.types";

/**
 * InfoCard's card, opened by clicking its target instead of hovering it: an optional header with a close button, a
 * bordered body and an optional footer. It is controlled: the consumer opens it from its target's click and closes it
 * from `onClose`, which Escape and a click outside call. Focus moves into it when it opens and back to the target when
 * it closes.
 * @param props.opened  Whether the card is open.
 * @param props.onClose Called when the card is dismissed with Escape or a click outside.
 */
const PopoverInfoCard = componentWrapper<CustomPopoverInfoCardFactory, IProps>(
    "PopoverInfoCard",
    ({ opened, onClose, ...props }, _ref) => (
        <Popover
            position="top"
            withArrow
            width={POPOVER_INFO_CARD_WIDTH}
            radius="lg"
            shadow="md"
            transitionProps={{ duration: 0 }}
            // Opened on purpose, it acts like a small dialog: focus moves into it, so Escape closes it.
            trapFocus
            returnFocus
            {...props}
            opened={opened}
            onDismiss={onClose}
        />
    )
);

PopoverInfoCard.Target = Popover.Target;
PopoverInfoCard.Dropdown = Dropdown;
PopoverInfoCard.Header = Header;
PopoverInfoCard.Body = Body;
PopoverInfoCard.Footer = Footer;

export { PopoverInfoCard };
